import { Component, OnInit, ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

import * as Models from '../../../../../../src/app/models/commonModels';
import { AldFormBaseComponent } from '../../../../../../src/app/shared/components/form/ald-form.component';
import { AuthenticationService } from '../../../../../../src/app/shared/services/authentication.service';
import { EnvironmentService } from '../../../../../../src/app/services/environment.service';
import { HelperService } from "../../../../../../src/app/services/helper/helper.service";

import { SettingsState } from '../../../../../../src/app/services/settings/settings.state';
import * as SettingsAction from '../../../../../../src/app/services/settings/settings.action';

import { User } from '../../../../../../src/app/models/user/user';

import { SettingsPreview } from '../../../../../../src/app/models/settings/settings';

import * as RelocationOrderModels from '../../../../../../src/app/models/relocation-order/relocation-order';
import { AldState } from "../../../../../../src/app/services/ald/ald.state";
import * as AldActions from "../../../../../../src/app/services/ald/ald.action";


@Component({
  selector: 'app-relocation-orders',
  templateUrl: './relocation-orders.component.html',
  styleUrls: ['./relocation-orders.component.css']
})

export class RelocationOrdersComponent extends AldFormBaseComponent implements OnInit {


  public requestGet: Models.RequestModel = null;

  public orders: RelocationOrderModels.RelocationOrderModel[];

  
  @Select(AldState.RelocationOrders)
  RelocationOrders$: Observable<Models.ResponseList<RelocationOrderModels.RelocationOrderModel>>;


    constructor(
        private formBuilder: FormBuilder,
        public router: Router,
        public authenticationService: AuthenticationService,
        public store: Store,
        public helperService: HelperService,
        public environmentService: EnvironmentService,
        public changeDetectorRef: ChangeDetectorRef
    ) {

      super(helperService, environmentService, changeDetectorRef, router, authenticationService, store);
    }

  ngOnInit() {

    super.ngOnInit();

    this.subscription.add(this.RelocationOrders$.subscribe((data) => {

      if (data && data.Success) {

        this.helperService.consoleLog("f f f f f " + data.Items.length);

        this.orders = data.Items;
        }
      }));
    }


  public onUserAuthenitcate() {

    if (this.currentUser && this.currentUser.CarId) {

      this.requestGet = new Models.RequestModel(this.currentUser.CarId);

      this.store.dispatch(new AldActions.RelocationOrdersGet(this.requestGet));
    }
  };

  public onSummary() { }
}
